import {
  API_POST_DASHBOARD_DAY_REPORT_COUNT_STATS,
  API_POST_DASHBOARD_GAS_SALES_STATS,
  API_POST_DASHBOARD_GAS_SALES_STATS_STORE_WISE,
  API_POST_DASHBOARD_SALES_STATS,
  API_POST_DASHBOARD_SALES_STATS_STORE_WISE,
  API_POST_DASHBOARD_STATS,
} from 'common/constants/apis';
import { CRASHLYTICS_AUTH_ERROR } from 'common/constants/errors';
import UILogger, { LogRecordType, LogSeverityType } from 'common/utils/logger';
import httpClient from './config';
import {
  IDashboardSalesStatsDataResp,
  IDashboardStatsDataResp,
  IDayReportDataStatsResp,
  IStatsSearchCriteria,
} from 'common/interfaces/idashboard';

export const getDashboardStats = async (
  storeId: number,
  criteria: IStatsSearchCriteria,
): Promise<IDashboardStatsDataResp> => {
  UILogger.log('DashboardStatsService: getDashboardStats');
  return httpClient
    .post(API_POST_DASHBOARD_STATS.replace('{storeId}', storeId.toString()), criteria)
    .then((res) => {
      UILogger.log('DashboardStatsService: getDashboardStats done, ', res.data);
      if (res.status === 200) {
        return res.data;
      }
      return { status: { success: false } } as IDashboardStatsDataResp;
    })
    .catch((error) => {
      if (error?.response?.status !== 401) {
        UILogger.log(
          {
            recordType: LogRecordType.CRASHLYTICS,
            severity: LogSeverityType.ERROR,
            error,
            tag: CRASHLYTICS_AUTH_ERROR,
          },
          'DashboardStatsService:Error in getDashboardStats',
          error,
        );
      }
      UILogger.log('DashboardStatsService:Error in getDashboardStats. status:', error?.response?.status);
      return { status: { success: false } } as IDashboardStatsDataResp;
    });
};

export const getDashboardSalesStats = async (
  storeId: number,
  criteria: IStatsSearchCriteria,
  type: 'dayReport' | 'gasReport',
): Promise<IDashboardSalesStatsDataResp> => {
  UILogger.log('DashboardStatsService: getDashboardSalesStats');
  const url = type === 'gasReport' ? API_POST_DASHBOARD_GAS_SALES_STATS : API_POST_DASHBOARD_SALES_STATS;
  return httpClient
    .post(url.replace('{storeId}', storeId.toString()), criteria)
    .then((res) => {
      UILogger.log('DashboardStatsService: getDashboardSalesStats done, ', res.data);
      if (res.status === 200) {
        return res.data;
      }
      return { status: { success: false } } as IDashboardSalesStatsDataResp;
    })
    .catch((error) => {
      if (error?.response?.status !== 401) {
        UILogger.log(
          {
            recordType: LogRecordType.CRASHLYTICS,
            severity: LogSeverityType.ERROR,
            error,
            tag: CRASHLYTICS_AUTH_ERROR,
          },
          'DashboardStatsService:Error in getDashboardSalesStats',
          error,
        );
      }
      UILogger.log('DashboardStatsService:Error in getDashboardSalesStats. status:', error?.response?.status);
      return { status: { success: false } } as IDashboardSalesStatsDataResp;
    });
};

export const getStoreWiseDashboardSalesStats = async (
  storeId: number,
  criteria: IStatsSearchCriteria,
  type: 'dayReport' | 'gasReport',
): Promise<IDashboardSalesStatsDataResp> => {
  UILogger.log('DashboardStatsService: getDashboardSalesStats');
  const url =
    type === 'gasReport' ? API_POST_DASHBOARD_GAS_SALES_STATS_STORE_WISE : API_POST_DASHBOARD_SALES_STATS_STORE_WISE;
  return httpClient
    .post(url.replace('{storeId}', storeId.toString()), criteria)
    .then((res) => {
      UILogger.log('DashboardStatsService: getDashboardSalesStats done, ', res.data);
      if (res.status === 200) {
        return res.data;
      }
      return { status: { success: false } } as IDashboardSalesStatsDataResp;
    })
    .catch((error) => {
      if (error?.response?.status !== 401) {
        UILogger.log(
          {
            recordType: LogRecordType.CRASHLYTICS,
            severity: LogSeverityType.ERROR,
            error,
            tag: CRASHLYTICS_AUTH_ERROR,
          },
          'DashboardStatsService:Error in getDashboardSalesStats',
          error,
        );
      }
      UILogger.log('DashboardStatsService:Error in getDashboardSalesStats. status:', error?.response?.status);
      return { status: { success: false } } as IDashboardSalesStatsDataResp;
    });
};

export const getDayReportCountStats = async (
  storeId: number,
  criteria: IStatsSearchCriteria,
): Promise<IDayReportDataStatsResp> => {
  UILogger.log('DashboardStatsService: getDayReportCountStats');
  const url = API_POST_DASHBOARD_DAY_REPORT_COUNT_STATS;
  return httpClient
    .post(url.replace('{storeId}', storeId.toString()), criteria)
    .then((res) => {
      UILogger.log('DashboardStatsService: getDayReportCountStats done, ', res.data);
      if (res.status === 200) {
        return res.data;
      }
      return { status: { success: false } } as IDayReportDataStatsResp;
    })
    .catch((error) => {
      if (error?.response?.status !== 401) {
        UILogger.log(
          {
            recordType: LogRecordType.CRASHLYTICS,
            severity: LogSeverityType.ERROR,
            error,
            tag: CRASHLYTICS_AUTH_ERROR,
          },
          'DashboardStatsService:Error in getDayReportCountStats',
          error,
        );
      }
      UILogger.log('DashboardStatsService:Error in getDashboardSalesStats. status:', error?.response?.status);
      return { status: { success: false } } as IDayReportDataStatsResp;
    });
};
